var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "language-selector" }, [
    _c("label", { staticClass: "label", attrs: { for: "language" } }, [
      _vm._v("Sprache wählen:"),
    ]),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedLanguage,
            expression: "selectedLanguage",
          },
        ],
        attrs: { id: "language" },
        on: {
          change: [
            function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.selectedLanguage = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
            _vm.handleChange,
          ],
        },
      },
      [
        _c("option", { attrs: { disabled: "", value: "" } }, [
          _vm._v("Bitte auswählen"),
        ]),
        _c(
          "optgroup",
          { attrs: { label: "Beliebte Sprachen" } },
          _vm._l(_vm.prioritizedLanguages, function (lang) {
            return _c("option", { key: lang, domProps: { value: lang } }, [
              _vm._v(" " + _vm._s(lang) + " "),
            ])
          }),
          0
        ),
        _c(
          "optgroup",
          { attrs: { label: "Weitere Sprachen" } },
          _vm._l(_vm.otherLanguages, function (lang) {
            return _c("option", { key: lang, domProps: { value: lang } }, [
              _vm._v(" " + _vm._s(lang) + " "),
            ])
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }